import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as CheckboxOffIcon } from '../../assets/images/svg/checkbox-off.svg';
import themeColors from '../../assets/styles/themeColors';

const CheckboxOffStyled = styled(CheckboxOffIcon)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  stroke: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const CheckboxOff = (props) => <CheckboxOffStyled {...props} />;

CheckboxOff.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

CheckboxOff.defaultProps = {
  w: '24px',
  h: '24px',
};

export default CheckboxOff;
